import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('judgeMe'),
  titleToNamespace: true,
  avatarPath: avatars.judgeMe,
  logoPath: logos.judgeMe,
  hasConnectionStatus: false
});
